const { filterObject } = require('../utils/records');

const INITIAL_STATE = {
  items: {},
};

module.exports = function LootReducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case 'SET_API_URL':
      return INITIAL_STATE;
    case 'SET_LANGUAGE':
    case 'INVALIDATE_LOOTS':
      return {
        items: Object.keys(state.items).reduce(
          (itemsObj, lootId) => ({
            ...itemsObj,
            [lootId]: Object.assign(state.items[lootId], {
              didInvalidate: true,
            }),
          }),
          {},
        ),
      };
    case 'FETCH_LOOT_IN_PROGRESS':
      return {
        items: {
          ...state.items,
          [action.lootId]: {
            ...(state.items[action.lootId] || {}),
            fetchingInProgressSince: action.timestamp,
          },
        },
      };
    case 'FETCH_LOOT_SUCCESSFUL':
      return {
        items: {
          ...filterObject(
            state.items,
            (itemKey) => itemKey !== action.loot?.urlAlias,
          ),
          [action.loot._id]: {
            ...(action.loot || {}),
            didInvalidate: false,
            fetchingInProgressSince: null,
            lastSuccessfulFetch: action.timestamp,
          },
        },
      };
    case 'FETCH_LOOT_FAILED':
      return {
        items: {
          ...state.items,
          [action.lootId]: {
            ...(state.items[action.lootId] || {}),
            fetchingInProgressSince: null,
            lastFailedFetch: action.timestamp,
            lastErrorMessage: action.reason,
          },
        },
      };
    default:
      return state;
  }
};
